import React from 'react';
import styled from 'styled-components';

const Wrapper = styled.div`
  display: flex;
  justify-content: center;
`;

const Label = styled.div`
  font-size: 12px;
  color: ${({ theme }) => theme.colors.grey4};
  white-space: nowrap;
  font-weight: 400;
  padding: 4px 12px;
  background: ${({ theme }) => theme.colors.grey2};
  border-radius: 8px;
  line-height: 20px;
  margin: 16px 0;
`;

const DateSeparator = ({ label, compact = false }) => (
  <Wrapper>
    <Label $compact={compact}>{label}</Label>
  </Wrapper>
);

export default DateSeparator;
